



























































































































import Vue from '@front-app/vendor/vue';
import {
	defineComponent,
	PropType,
	ref,
	Ref,
	watch,
} from '@vue/composition-api';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { NoteMessage, ReadStatus } from '@front-app/services/NoteApi/NoteModels';
import { getNotePageStore } from '@front-app/store/modules/notePage';
import { Size } from '@front-app/components/constants';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import HeightTransition from '@front-app/components/transitions/Height.vue';
import { UserSearchItem } from '@front-app/services/UserApi/UserModel';
import { UserStore } from '@front-app/store/singletons/User';
import { STATUS } from '@front-app/constants/state';
import SelectedUserButton from '@front-app/components/buttons/SelectedUserButton.vue';
import {
	getDeeplinkPaginationConfig,
	getFirstPagePaginationConfig,
} from './util/paginationConfig';
import NoteReplyForm from './NoteReplyForm.vue';
import NoteMessageComponent from './NoteMessage.vue';
import FullWidthPanelRow from '../modals/FullWidthPanelRow.vue';
import SearchGroupUsers from '../inputs/SearchGroupUsers.vue';
import { SearchOption } from '../search/useSearch';

export default defineComponent({
	components: {
		CtaButton,
		NoteMessageComponent,
		FullWidthPanelRow,
		HeightTransition,
		NoteReplyForm,
		SearchGroupUsers,
		SelectedUserButton,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		noteId: {
			type: String,
			required: true,
		},
		messages: {
			type: Array as PropType<NoteMessage[]>,
			required: true,
		},
		participantIds: {
			type: Array as PropType<string[]>,
			required: true,
		},
		deeplinkNoteMessageId: {
			type: String,
			default: '',
		},
		isSendingInvitations: Boolean,
	},
	setup(props, ctx) {
		const config = props.deeplinkNoteMessageId
			? getDeeplinkPaginationConfig(props.messages, props.deeplinkNoteMessageId)
			: getFirstPagePaginationConfig(props.messages);
		const {
			messages: visibleMessages,
			canPageBackward,
			canPageForward,
			isLoadingBackward,
			isLoadingForward,
			pageForward,
			pageBackward,
			reply,
		} = getNotePageStore(
			props.noteId,
			props.messages,
			config,
		);

		// Reply form
		const isReplyFormVisible = ref(false);
		const replyFormElement: Ref<Vue | null> = ref(null);
		const scrollToReplyForm = () => {
			const form = replyFormElement.value;
			if (!form) {
				return;
			}
			const el = form.$el.querySelector('.ProseMirror') as null | HTMLTextAreaElement;
			if (el) {
				el.focus();
				el.scrollIntoView({ behavior: 'smooth' });
			}
		};
		const isSendingReply = ref(false);
		const performReply = async (message: string) => {
			isSendingReply.value = true;
			const newMessage = await reply(message);
			isSendingReply.value = false;
			isReplyFormVisible.value = false;
			ctx.emit('submit-reply', newMessage);
		};
		// END reply form

		// Invite form
		const isInviteFormVisible = ref(false);
		const selectedUserIds: Ref<string[]> = ref([]);
		const selectUser = (user: SearchOption<UserSearchItem>) => {
			UserStore.getInstance().setPartial({
				...user.original,
				status: STATUS.SUCCESS,
			});
			if (!selectedUserIds.value.includes(user.original.id)) {
				selectedUserIds.value = [user.original.id, ...selectedUserIds.value];
			}
		};
		const removeUser = (userId: string) => {
			selectedUserIds.value = selectedUserIds.value.filter((id: string) => id !== userId);
		};
		watch(() => props.isSendingInvitations, (curr, prev) => {
			if (!prev && curr) {
				selectedUserIds.value = [];
				isInviteFormVisible.value = false;
			}
		});
		// END invite form
		return {
			visibleMessages,
			canPageBackward,
			canPageForward,
			isLoadingBackward,
			isLoadingForward,
			pageForward,
			pageBackward,
			ReadStatus,
			// Reply form
			performReply,
			isReplyFormVisible,
			replyFormElement,
			scrollToReplyForm,
			isSendingReply,
			// Invite form
			selectedUserIds,
			isInviteFormVisible,
			selectUser,
			removeUser,
			// Util
			Size,
			ButtonPalettes,
		};
	},
});
